<template>
  <div style="background-color: transparent;">
    <div class="">
        <div id="prebarclock" class="clock-preview barfont" :class="foreColor">
          <span class="prebartime">{{ hours }}:{{ minutes }}
            <div class="prebarssub-area">
                <span class="prebarampm">{{ ampm }}</span>
                <span class="pretimezone" :class="timezoneTextColor">{{ timezoneAbbreviation }}</span>
            </div>
          </span>
        </div>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "premiumBarDesign",
  data() {
    return {
      hours: "",
      minutes: "",
      ampm: "",
      timezoneAbbreviation: "",
      color: this.$route.query.color || 'green',
      selectedCountry: 'JP',
      timezone: this.normalizeTimezone(this.$route.query.timezone) || 'Asia/Tokyo',
      countries: [
        {
          code: 'JP',
          name: '日本',
          timezones: [
            { label: '日本標準時 (JST)', value: 'Asia/Tokyo', abbreviation: 'JST' }
          ]
        },
        {
          code: 'CN',
          name: '中国',
          timezones: [
            { label: '中国標準時 (CST)', value: 'Asia/Shanghai', abbreviation: 'CST' }
          ]
        },
        {
          code: 'KR',
          name: '韓国',
          timezones: [
            { label: '韓国標準時 (KST)', value: 'Asia/Seoul', abbreviation: 'KST' }
          ]
        },
        {
          code: 'TW',
          name: '台湾',
          timezones: [
            { label: '台湾標準時 (CST)', value: 'Asia/Taipei', abbreviation: 'CST' }
          ]
        },
        {
          code: 'HK',
          name: '香港',
          timezones: [
            { label: '香港標準時 (HKT)', value: 'Asia/Hong_Kong', abbreviation: 'HKT' }
          ]
        },
        {
          code: 'ID',
          name: 'インドネシア',
          timezones: [
            { label: '西部インドネシア時間 (WIB)', value: 'Asia/Jakarta', abbreviation: 'WIB' },
            { label: '中央インドネシア時間 (WITA)', value: 'Asia/Makassar', abbreviation: 'WITA' },
            { label: '東部インドネシア時間 (WIT)', value: 'Asia/Jayapura', abbreviation: 'WIT' }
          ]
        },
        {
          code: 'TH',
          name: 'タイ',
          timezones: [
            { label: 'インドシナ時間 (ICT)', value: 'Asia/Bangkok', abbreviation: 'ICT' }
          ]
        },
        {
          code: 'US',
          name: 'アメリカ合衆国',
          timezones: [
            { label: '東部標準時 (EST)', value: 'America/New_York', abbreviation: 'EST' },
            { label: '中央標準時 (CST)', value: 'America/Chicago', abbreviation: 'CST' },
            { label: '山岳標準時 (MST)', value: 'America/Denver', abbreviation: 'MST' },
            { label: '太平洋標準時 (PST)', value: 'America/Los_Angeles', abbreviation: 'PST' }
          ]
        },
        {
          code: 'GB',
          name: 'イギリス',
          timezones: [
            { label: 'グリニッジ標準時 (GMT)', value: 'Europe/London', abbreviation: 'GMT' }
          ]
        },
        {
          code: 'BG',
          name: 'ブルガリア',
          timezones: [
            { label: '東ヨーロッパ時間 (EET)', value: 'Europe/Sofia', abbreviation: 'EET' }
          ]
        },
        {
          code: 'AU',
          name: 'オーストラリア',
          timezones: [
            { label: 'オーストラリア東部標準時 (AEST)', value: 'Australia/Sydney', abbreviation: 'AEST' },
            { label: 'オーストラリア中央標準時 (ACST)', value: 'Australia/Adelaide', abbreviation: 'ACST' },
            { label: 'オーストラリア西部標準時 (AWST)', value: 'Australia/Perth', abbreviation: 'AWST' }
          ]
        },
        // 必要に応じて他の国とタイムゾーンを追加してください
      ],
    };
  },

  computed: {
    foreColor() {
      const colorMap = {
        green: 'green-gradient-background',
        blue: 'blue-gradient-background',
        red: 'red-gradient-background',
        sky: 'sky-gradient-background',
        yellow: 'yellow-gradient-background',
        lush: 'lush-gradient-background',
        moon: 'moon-gradient-background',
        rose: 'rose-gradient-background',
        steel: 'steel-gradient-background',
        gray: 'gray-gradient-background',
        transparentwhite: 'transparent-white-background',
        transparent: 'transparent-background'
      };
      return colorMap[this.color] || '';
    },
    timezoneTextColor() {
      const textColorMap = {
        green: 'green-text-color',
        blue: 'blue-text-color',
        red: 'red-text-color',
        sky: 'sky-text-color',
        yellow: 'yellow-text-color',
        lush: 'lush-text-color',
        moon: 'moon-text-color',
        rose: 'rose-text-color',
        steel: 'steel-text-color',
        gray: 'gray-text-color',
        transparentwhite: 'transparent-text-color',
        transparent: 'transparent-text-color'
      };
      return textColorMap[this.color] || '';
    },
    filteredTimezones() {
      const country = this.countries.find(c => c.code === this.selectedCountry);
      return country ? country.timezones : [];
    }
  },
  watch: {
    selectedCountry(newCountry) {
      const country = this.countries.find(c => c.code === newCountry);
      if (country && country.timezones.length > 0) {
        this.timezone = country.timezones[0].value;
        this.timezoneAbbreviation = country.timezones[0].abbreviation;
      } else {
        this.timezone = '';
        this.timezoneAbbreviation = '';
      }
    },
    timezone: {
      immediate: true,
      handler() {
        this.setTimezoneAbbreviation();
      }
    }
  },
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 1000);
    this.setTimezoneAbbreviation();
  },
  methods: {
    setInitialTimezoneAbbreviation() {
      const country = this.countries.find(c => c.code === this.selectedCountry);
      if (country) {
        const tz = country.timezones.find(t => t.value === this.timezone);
        this.timezoneAbbreviation = tz ? tz.abbreviation : '';
      }
    },
    updateTime() {
      const now = new Date();
      const options = {
        timeZone: this.normalizeTimezone(this.timezone),
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const parts = formatter.formatToParts(now);
      let hour, minute, dayPeriod;
      parts.forEach(part => {
        if (part.type === 'hour') hour = part.value;
        if (part.type === 'minute') minute = part.value;
        if (part.type === 'dayPeriod') dayPeriod = part.value.toLowerCase();
      });
      this.hours = this.zeroPadding(parseInt(hour), 2);
      this.minutes = this.zeroPadding(parseInt(minute), 2);
      this.ampm = dayPeriod === 'am' ? 'am' : 'pm';
    },
    zeroPadding(num, len) {
      return num.toString().padStart(len, '0');
    },
    normalizeTimezone(tz) {
      if (!tz) return null;
      // %2Fや%2fを/に置換
      return tz.replace(/%2F/gi, '/');
    },
    setTimezoneAbbreviation() {
      const normalizedTimezone = this.normalizeTimezone(this.timezone);
      const country = this.countries.find(c => c.timezones.some(t => t.value === normalizedTimezone));
      if (country) {
        const tz = country.timezones.find(t => t.value === normalizedTimezone);
        this.timezoneAbbreviation = tz ? tz.abbreviation : '';
      } else {
        this.timezoneAbbreviation = '';
      }
      console.log('Timezone Abbreviation set to:', this.timezoneAbbreviation); // デバッグ用
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.content-title{
  text-align: center;
}

h2{
  position: relative;
  display: inline-block;
  padding: 0 65px;
  text-align: center;
  letter-spacing: 1px
}

h2:before,
h2:after {
  position: absolute;
  top: calc(50% - 3px);
  width: 50px;
  height: 6px;
  content: '';
  border-top: solid 2px #000;
  border-bottom: solid 2px #000;
}

h2:before {
  left: 0;
}

h2:after {
  right: 0;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.main{
  max-width: 514px;
  margin: 0 auto;
}

#prebarclock {
  width: 220px;
  height: 70px;
  padding: 10px 28px 0px 28px;
  margin: 12px;
  border-radius: 2vh;
  color: #fff;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.prebartime {
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  font-size: 52px;
  margin-bottom: 8px;
}

.prebarssub-area{
  display: flex;
  flex-direction: column; /* 縦方向に配置 */
  line-height: 0.8;
  margin-left: 10px;
}

.prebarampm {
  font-size: 0.5em;
}

.pretimezone {
  font-size: 0.3em;
  margin-top: 2px;
  background-color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
}

.set{
  padding: 8px 12px 24px 12px;
  margin-top: 24px;
  background-color: #f9f3e9;
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}


.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}



.yellow-gradient-background {
  background: linear-gradient(260deg, #F3F9A7 0%, #CAC531 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.lush-gradient-background {
  background: linear-gradient(260deg, #56ab2f 0%, #a8e063 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.moon-gradient-background {
  background: linear-gradient(260deg, #4e54c8 0%, #8f94fb 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}
.rose-gradient-background {
  background: linear-gradient(260deg, #f4c4f3 0%, #fc67fa 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}
.steel-gradient-background {
  background: linear-gradient(260deg, #1F1C2C 0%, #928DAB 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}
.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.barfont{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.radio-main{
  display: flex;
  flex-wrap: wrap;
  margin-top:12px;
  box-sizing: border-box;
}

.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  transform: translateY(4px);
  border-bottom: none;
}

.country-timezone-select {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.country-select, .timezone-select {
  display: flex;
  flex-direction: column;
}

.country-select label, .timezone-select label {
  margin-bottom: 8px;
  font-weight: bold;
}

.country-select select, .timezone-select select {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

/* グラデーションに対応するフォントカラー */
.green-text-color {
  color: #80D0C7; /* グリーン */
}
.blue-text-color {
  color: #FF5ACD; /* ブルー */
}
.red-text-color {
  color: #C850C0; /* レッド */
}
.sky-text-color {
  color: #97D9E1; /* スカイ */
}
.yellow-text-color {
  color: #CAC531; /* イエロー */
}
.lush-text-color {
  color: #56ab2f; /* ラッシュ */
}
.moon-text-color {
  color: #4e54c8; /* ムーン */
}
.rose-text-color {
  color: #fc67fa; /* ローズ */
}
.steel-text-color {
  color: #928DAB; /* スティール */
}
.gray-text-color {
  color: #304352; /* グレー */
}

.transparent-background {
  background: transparent;
  color: #555!important;
}

.transparent-text-color {
  color: #555;
  border: 1px solid #ccc;
}

.transparent-white-background {
  background: transparent;
  color: #fff!important;
}
</style>